module.exports = __webpack_public_path__ + "287b8153cb1d6e1e51700e1475c55b10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/water-icon.png
// module id = 813
// module chunks = 0